<template>
    <CCard>
        <CCardBody>
            <v-toolbar flat color="white">
                <v-toolbar-title>گزارش فروش فروشگاه ها</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <CCard>
                <CCardHeader>
                    <CIcon name="cil-justify-center"/>
                    <strong> فیلتر </strong>
                </CCardHeader>
                <CCardBody>
                    <CRow>
                        <!-- انتخاب فروشگاه -->
                        <CCol sm="3">
                            <label>فروشگاه</label>
                            <select class="form-control" v-model="filters.shop_id">
                                <option v-for="shop in shopList"
                                        :key="shop.id"
                                        :value="shop.id">{{ shop.name }}
                                </option>
                            </select>
                        </CCol>

                        <!-- از تاریخ -->
                        <CCol sm="3">
                            <label>از تاریخ</label>
                            <date-picker v-model="filters.from_date"
                                         input-format="YYYY-MM-DD"
                                         locale="fa" format="YYYY-MM-DD"
                                         display-format="jYYYY-jMM-jDD">
                            </date-picker>
                        </CCol>

                        <!-- تا تاریخ -->
                        <CCol sm="3">
                            <label>تا تاریخ</label>
                            <date-picker v-model="filters.to_date"
                                         input-format="YYYY-MM-DD"
                                         locale="fa" format="YYYY-MM-DD"
                                         display-format="jYYYY-jMM-jDD">
                            </date-picker>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter class="text-left">
                    <CButton size="sm" color="primary" class="text-white" @click="applyFilters">
                        <CIcon name="cil-check-circle"/>
                        اعمال
                    </CButton>
                    <CButton size="sm" color="danger" class="text-white mr-1" @click="resetFilters">
                        <CIcon name="cil-ban"/>
                        حذف فیلتر ها
                    </CButton>
                </CCardFooter>
            </CCard>

            <CCollapse :show="collapse" :duration="400">
                <CRow class="text-left" dir="ltr">
                    <CButton color="dark" class="mb-2 ml-2 text-white"
                             v-c-tooltip="'خروجی بصورت فایل PDF'"
                             @click="refreshreports('pdf')">
                        <CIcon :content="$options.iconsSet.cilFilePdf"/>
                    </CButton>
                    <CButton color="dark" class="mb-2 ml-2 text-white"
                             v-c-tooltip="'خروجی بصورت فایل اکسل'"
                             @click="refreshreports('excel')">
                        <CIcon :content="$options.iconsSet.cilFileExcel"/>
                    </CButton>
                </CRow>

                <v-data-table
                        :headers="headers"
                        :items="ReportResult"
                        :items-per-page="100"
                        :footer-props="{
                            'items-per-page-options': [25, 50, 100]
                        }"
                        class="elevation-1">
                    <template v-slot:item="{item}">
                        <tr>
                            <td>{{ item.index }}</td>
                            <td>{{ item.key }}</td>
                            <td>{{ item.value }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </CCollapse>
        </CCardBody>
    </CCard>
</template>

<script>
    import {getFunction, formatDate} from '../../webservice/webservice';
    import {iconsSet} from '../../assets/icons/icons';
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

    export default {
        name: 'ShopCardex',
        props: {},
        iconsSet,
        components: {
            datePicker: VuePersianDatetimePicker
        },
        data: () => {
            return {
                headers: [
                    {text: 'ردیف', value: 'index'},
                    {text: 'عنوان', value: 'key'},
                    {text: 'مقدار', value: 'value'},
                ],
                ReportResult: [],
                ReportResultCount: 0,
                shopList: [],
                collapse: false,
                filters: {
                    shop_id: '',
                    from_date: formatDate(new Date((+new Date) - 2678400000)),
                    to_date: formatDate(new Date()),
                },
            }
        },
        mounted() {
            this.getShopList();
            this.refreshreports();
        },
        methods: {
            // دریافت لیست فروشگاه‌ها
            getShopList() {
                // TODO: آدرس واقعی وبسرویس لیست فروشگاه‌ها را جایگزین کنید
                getFunction(this.$http, 'accounting/get_shop_list', 0, 0, 'name', 'desc', {}).then((resp) => {
                    if (resp && resp.list) {
                        this.shopList = resp.list;
                        if (this.shopList.length > 0 && !this.filters.shop_id) {
                            this.filters.shop_id = this.shopList[0].id;
                        }
                    }
                });
            },

            // حذف فیلدهای خالی و تبدیل به رشته (مطابق الگوی نمونه)
            sanitizeFilters(filters) {
                Object.keys(filters).forEach((key) => {
                    if (filters[key] === '' || filters[key] === null || filters[key] === undefined) {
                        delete filters[key];
                    } else {
                        filters[key] = `${filters[key]}`;
                    }
                });
                return filters;
            },

            applyFilters() {
                this.collapse = true;
                this.refreshreports();
            },

            resetFilters() {
                this.filters.shop_id = (this.shopList.length > 0) ? this.shopList[0].id : '';
                this.filters.from_date = formatDate(new Date((+new Date) - 2678400000));
                this.filters.to_date = formatDate(new Date());
                this.refreshreports();
            },

            refreshreports(fileType) {
                let filters = this.sanitizeFilters(Object.assign({}, this.filters));

                getFunction(
                    this.$http,
                    'accounting/shop_cardex_report',
                    0,            // start
                    100,          // limit
                    'name',       // sort
                    'desc',       // order
                    filters,      // { shop_id, from_date, to_date }
                    fileType
                ).then((resp) => {
                    if (fileType !== undefined) {
                        if (fileType === 'pdf') {
                            window.open(resp.fileurl, '_blank');
                            return;
                        }
                        const link = document.createElement('a');
                        link.href = resp.fileurl;
                        link.setAttribute('download', 'shop_cardex_report.' + ((fileType === 'pdf') ? 'pdf' : 'xls'));
                        document.body.appendChild(link);
                        link.click();
                    } else {
                        this.ReportResult = resp.list;
                        this.ReportResultCount = resp.count;
                    }
                });
            },
        },
    }
</script>
